import { Injectable, isDevMode } from '@angular/core';

export class BaseService {

    private _apiURL: string;

    constructor() {
        //this._apiURL = "http://api-test.promotorevents.com:1234/"; 
        //this._apiURL = "http://localhost:9000/"; 
        this._apiURL = "https://api.promotorevents.com:4443/";
    }

    protected getAPIURL(): string {
        return this._apiURL;
    }

    protected getBasePath(): string {
        return this.getAPIURL() + "api/";
    }

}



// WEBPACK FOOTER //
// ./src/app/services/base.service.ts